import { useSyncExternalStore } from "react";

/** The layout breakpoints, kept in step with shell.module.css. */
export const PHONE = "(max-width: 720px)";
/** Below this a screen's own menu folds into a disclosure at the top of the page. */
export const NARROW = "(max-width: 860px)";

/** Whether a media query matches now, following it as the window changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
